import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import MaterialKit from "./plugins/material-kit";

Vue.config.productionTip = false;

Vue.use(MaterialKit);

const NavbarStore = {
  showNavbar: false
};

Vue.mixin({
  data() {
    return {
      NavbarStore
    };
  }
});

// Load external script directly
function loadExternalScript(src) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

// Load the Elfsight platform script
/* eslint-disable no-console */
loadExternalScript("https://apps.elfsight.com/p/platform.js")
  .catch(error => console.error('Error loading script:', error));
/* eslint-enable no-console */

new Vue({
  el: "#app",
  router,
  render: h => h(App),
  mounted() {
    // Emit the render-event for prerendering
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount("#app");
